import { SubmitScreen } from "@/interactors/ApplicationSubmitScreen";

export default function Submit() {
  return <SubmitScreen />;
}
